var isProduction = process.env.NODE_ENV === 'production'

import $ from 'jquery'
import mc from '@/components/common/mc-lib'
import {
  mcAddressData
} from '@/assets/data/address-picker.data.js'

const dateFormat = (dateStr, formatStr) => {
  if (!dateStr || dateStr === '') return '-/-/-'
  let date = new Date(dateStr)
  var map = {
    'M': date.getMonth() + 1, // 月份
    'd': date.getDate(), // 日
    'h': date.getHours(), // 小时
    'm': date.getMinutes(), // 分
    's': date.getSeconds(), // 秒
    'q': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  formatStr = formatStr.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t]
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v
        v = v.substr(v.length - 2)
      }
      return v
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length)
    }
    return all
  })
  return formatStr
}

/**
 * 通用过滤函数
 */
export const filter = {
  filters: {
    codeToText(value, data, defaultTxt) {
      value = value + ''
      let result
      if (defaultTxt === undefined) {
        defaultTxt = '请选择'
      }
      if (value && data) {
        result = data.filter((item) => {
          return item.value + '' === value
        })
        if (result.length > 0) {
          return result[0].text
        } else {
          return defaultTxt
        }
      } else {
        return defaultTxt
      }
    },
    dateFormat(dateStr, formatStr = 'yyyy-MM-dd') {
      return dateFormat(dateStr, formatStr)
    },
    dateFormatPower(dateStr) {
      let date = new Date(dateStr)
      let formatStr
      let nowDate = new Date()
      if (date.getFullYear() === nowDate.getFullYear() &&
        date.getMonth() === nowDate.getMonth() &&
        date.getDate() === nowDate.getDate()) {
        formatStr = 'hh:mm'
      } else {
        formatStr = 'MM-dd hh:mm'
      }
      return dateFormat(dateStr, formatStr)
    }
  },
  methods: {
    codeToText(value, data, defaultTxt) {
      value = value + ''
      let result
      defaultTxt = defaultTxt || ''
      if (value && data) {
        result = data.filter((item) => {
          return item.value === value
        })
        if (result.length > 0) {
          return result[0].text
        } else {
          return defaultTxt
        }
      } else {
        return defaultTxt
      }
    }
  }
}

/**
 * 百度文本编辑器配置项
 */
export const editorConfig = {
  data() {
    return {
      UEditorPath: (isProduction ? '' : 'http://localhost:7178') + '/Content/Include/js/lib/utf8-net/'
    }
  }
}

/**
 * 手机验证码
 */
export const mobileVerify = {
  data() {
    return {
      canSendVeify: true,
      verifyTxt: '获取验证码'
    }
  },
  methods: {
    // 验证码倒计时
    verifyCountDown() {
      let time = 60
      let countdown = setInterval(() => {
        if (time > 1) {
          time--
          this.verifyTxt = `${time}秒`
        } else {
          this.verifyTxt = '获取验证码'
          clearInterval(countdown)
          this.canSendVeify = true
        }
      }, 1000)
    },
    // 获取验证码
    sendVerifyCode(mobile) {
      var _this = this
      if (mobile && this.canSendVeify) {
        this.canSendVeify = false
        mc.Ajax({
          url: '/User/GetVerifycode',
          data: {
            Telephone: mobile
          },
          success(response) {
            _this.$message.success('发送成功')
            _this.verifyCountDown()
            // 测试代码 - 自动填写验证码
            // _this.updateForm.VcCode = response.description
          },
          fail(response) {
            _this.$message.error(response.description)
            _this.canSendVeify = true
          }
        })
      }
    }
  }
}

/**
 * 地址选择
 */
export const addressConfig = {
  data() {
    return {
      addressProp: {
        label: 'name',
        value: 'code',
        children: 'children'
      },
      addressData: $.extend(true, [], mcAddressData) // 省市区数据
    }
  }
}

// /**
//  * 地址选择，除去中国全境，全省，全市
//  */
// export const addressConfigWithoutAll = {
//   data() {
//     return {
//       addressProp: {
//         label: 'name',
//         value: 'code',
//         children: 'children'
//       },
//       addressData: (() => {
//         let addressData = mcAddressData.filter(i => {
//           if (i.children && i.children.length > 0) {
//             i.children = i.children.filter(j => {
//               if (j.children && j.children.length > 0) {
//                 j.children = j.children.filter(k => k.code !== '-1')
//                 if (j.children.length === 0) delete j.children
//               }
//               return j.code !== '-1'
//             })
//             if (i.children.length === 0) delete i.children
//           }
//           return i.code !== '-1'
//         })
//         return addressData
//       })() // 省市区数据
//     }
//   }
// }

/**
 * 验证码混合对象
 */
export const verify = {
  data() {
    return {

    }
  },
  methods: {
    required(msg, type = 'string') {
      return {
        type: type,
        required: true,
        validator(rule, value, callback) {
          value = value + ''
          if (!value.trim()) {
            callback(new Error(`请输入${msg}`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    },
    requiredCheck(msg) {
      return {
        type: 'array',
        required: true,
        message: `请至少选择一项${msg}`,
        trigger: 'change'
      }
    },
    requiredSelect(msg, type = 'string') {
      return {
        type: type,
        required: true,
        message: `请选择${msg}`,
        trigger: 'change'
      }
    },
    // 类型验证
    check(type, msg) {
      return {
        type: type,
        required: true,
        message: `请输入正确的${msg}`,
        trigger: 'blur'
      }
    },
    // 手机号验证
    checkMobile(msg) {
      return {
        required: true,
        validator(rule, value, callback) {
          if (!/^(0|86|17951)?1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/.test(value)) {
            callback(new Error(`请输入正确的${msg}`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    },
    // 身份证验证码
    checkIdcrad(msg) {
      return {
        required: true,
        validator(rule, value, callback) {
          if (!/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value)) {
            callback(new Error(`请输入正确的${msg}`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    },
    // 银行卡验证(弱)
    checkBankcrad(msg) {
      return {
        required: true,
        validator(rule, value, callback) {
          if (!/^([1-9]{1})(\d{14}|\d{18})$/.test(value)) {
            callback(new Error(`请输入正确的${msg}`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    },
    // 全中文验证
    checkChinese(msg) {
      return {
        required: true,
        validator(rule, value, callback) {
          if (!/^[\u4E00-\u9FA5]+$/.test(value)) {
            callback(new Error(`${msg}请输入中文`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    },
    // 车牌号验证
    checkCarLicence(msg) {
      return {
        required: true,
        validator(rule, value, callback) {
          if (!/^[冀豫云辽黑湘皖鲁苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼渝京津沪新京军空海北沈兰济南广成使领A-Z]{1}[a-zA-Z0-9]{5}[a-zA-Z0-9挂学警港澳]{1}$/.test(value)) {
            callback(new Error(`请输入正确的${msg}`))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    }
  }
}

export default {
  filter: filter,
  editorConfig: editorConfig,
  mobileVerify: mobileVerify,
  addressConfig: addressConfig,
  // addressConfigWithoutAll: addressConfigWithoutAll,
  verify: verify
}



// WEBPACK FOOTER //
// ./src/components/common/mixin.js